const { functions } = require('lodash');

var radius = 20;
var circumference = radius * 2 * Math.PI;
// var navScroll;

$('section').each(function (i, elem) {
    var $nav = $('nav'),
        $this = $(this);
    
    //forward scroll
    new ScrollMagic.Scene({
        offset: -10, // Number of pixels user can scroll before panel snaps into place
        triggerElement: elem,
        triggerHook: 0, // Trigger this scene when top of panel hit top window
    })
    .on('start', function(event) {
        if(event.scrollDirection == 'FORWARD') {
            var dataCLS = ($this.data('cls')) ? $this.data('cls') : 'cover',
                pos = $this.data('pos'),
                total = $('section[data-cls="' +dataCLS+ '"]').length;
            if (dataCLS == 'cover') {
                $nav.removeClass('active');
                $('header .progress-nav .item').removeClass('active');

            } else {
                $nav.addClass('active');
                
                updateRing(dataCLS, pos, total);
            }
        }
    })
    .on('leave', function(event) {
        if(event.scrollDirection == 'REVERSE') {
            if($this.prev().hasClass('scrollmagic-pin-spacer')) {
                var dataCLS = ($this.prev().children('section').data('cls')) ? $this.prev().children('section').data('cls') : 'cover',
                pos = $this.prev().children('section').data('pos'),
                total = $('section[data-cls="' +dataCLS+ '"]').length;
            } else {
                var dataCLS = ($this.prev().data('cls')) ? $this.prev().data('cls') : 'cover',
                pos = $this.prev().data('pos'),
                total = $('section[data-cls="' +dataCLS+ '"]').length;
            }

            if (dataCLS == 'cover') {
                $nav.removeClass('active');
                $('header .progress-nav .item').removeClass('active');
            } else {
                $nav.addClass('active');
                
                updateRing(dataCLS, pos, total);
            }
        }
    })
    .addTo(require('./scrollInit'));
});

$(".progress-ring").each(function(){
    var circle = $(this).children('.progress-ring__circle');

    circle.css('stroke-dasharray', `${circumference} ${circumference}`);
    circle.css('stroke-dashoffset', `${circumference}`);
    updateProgress(circle, 0);

});

function updateRing(dataCLS, pos, total) {
    $('nav .item').removeClass('active');
    $('nav .item.'+dataCLS).addClass('active');
    $('header .progress-nav .item').removeClass('active');
    $('header .progress-nav .item.'+dataCLS).addClass('active');
    var circle = $('nav .item.'+dataCLS+' .progress-ring').children('.progress-ring__circle');
    var circle_mobile = $('header .progress-nav .item.'+dataCLS+' .progress-ring').children('.progress-ring__circle');
    var percent = parseFloat((pos*100)/total);
    setTimeout(() => {
        updateProgress(circle, percent);
        updateProgress(circle_mobile, percent);
    }, 500);
}

function updateProgress(circle, percent) {
    // console.log(circle);

    const offset = circumference - percent / 100 * circumference;
    circle.css('stroke-dashoffset', offset);
}

$(document).ready(function () {
    $('nav').outerHeight($(window).height());
    
    $(window).resize(function () { 
        $('nav').outerHeight($(window).height());
    });
    
    $('header .mobile-menu').click(function (e) { 
        e.preventDefault();
        $('.overlay').fadeIn();
        $('nav').addClass('mobile-active');
    });
    
    $('nav .close-menu').click(function (e) { 
        e.preventDefault();
        $('.overlay').fadeOut();
        $('nav').removeClass('mobile-active');
    });

    $('nav .content a').click(function (e) { 
        // e.preventDefault();
        $('.overlay').addClass('active');

        setTimeout(() => {
            $('.overlay').removeClass('active');
            if ($(window).width() < 1025) {
                $('.overlay').fadeOut();
                $('nav').removeClass('mobile-active');
            }
        }, 2000);
    });
    
    $('header .logo, .content-topic5-sidebar-pantau-pelaksanaan .footer a, a[href="#topik-5-2"]').click(function (e) { 
        // e.preventDefault();
        $('.overlay').addClass('active');

        setTimeout(() => {
            $('.overlay').removeClass('active');
            $('.overlay').fadeOut();
        }, 2000);
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        
        if ($(window).width() < 1025) {
            var st = $(this).scrollTop();

            if (st > 0) {
                if (st <= lastScrollTop) {
                    $("header").addClass("fixed-top");
                    $("header").addClass("scrolling");
                }
            } else {
                $("header").removeClass("fixed-top");
                $("header").removeClass("scrolling");
            }
    
            if (st > $("header").height()) {
                if (st > lastScrollTop) {
                    $("header").addClass("scroll-down");
                    $("header").removeClass("scroll-up");
                } else {
                    $("header").removeClass("scroll-down");
                    $("header").addClass("scroll-up");
                }
            } else {
                $("header").removeClass("scroll-up");
                $("header").removeClass("scroll-down");
            }
            lastScrollTop = st;
        }
    });    
});